import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector, APP_INITIALIZER, LOCALE_ID, ApplicationModule, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { PlatformLocation, registerLocaleData, CommonModule } from '@angular/common';

// import { AbpModule } from '../node_modules/abp-ng2-module/dist/src/abp.module';
//import { AbpHttpInterceptor, AbpHttpConfiguration } from 'abp-ng2-module/dist/src/abpHttpInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from './shared/shared.module';
import { ServiceProxyModule } from './shared/service-proxies/service-proxy.module';
import { RootRoutingModule } from './root-routing.module';

import { AppConsts } from './shared/AppConsts';
import { AppSessionService } from './shared/session/app-session.service';
import { API_BASE_URL, SessionServiceProxy, TokenAuthServiceProxy, UserServiceProxy, CustomerServiceProxy, PageServiceProxy, WarehouseServiceProxy, ProductServiceProxy, UserPermissionServiceProxy, AddressServiceProxy, ReportServiceProxy, TitleServiceProxy, UserCustomerServiceProxy, UserAuthorizationServiceProxy, UserReportServiceProxy, AuthorizationTypeServiceProxy, UserCitiesServiceProxy, CityServiceProxy, CategoryServiceProxy, UserAddressServiceProxy, UserWarehouseServiceProxy, UserFormsServiceProxy, UserCitiesCategoriesServiceProxy, UserProductAttributeServiceProxy, ProductAttributeServiceProxy, OrderApprovalTaskRepairServiceProxy, AccountServiceProxy, OrderApprovalRulesServiceProxy, UserManagementSummaryServiceProxy, WarehouseOwnerServiceProxy, MetabaseTranspopPortalModuleServiceProxy, MetabaseTranspopPortalFilterServiceProxy, ProductDamageStatusServiceProxy, UserPagesServiceProxy, ModuleServiceProxy, UserModuleServiceProxy, UserRoleServiceProxy, PosmProductionServiceProxy, TransportBidServiceProxy, PosmProductionRequestServiceProxy, ResolveServiceProxy, ProcessTrackingServiceProxy, GoogleMapsServiceProxy, RouteServiceProxy, UserRouteStartLocationServiceProxy, OrderCartServiceProxy, CustomerThemeServiceProxy, MetabaseTranspopPortalProcessServiceProxy } from './shared/service-proxies/service-proxies';

import { RootComponent } from './root.component';

import { ModalModule } from 'ngx-bootstrap';
import { HttpClientModule } from '@angular/common/http';

import { GestureConfig, MatProgressSpinnerModule, MatButtonModule, MatMenuModule, MatSelectModule, MatInputModule, MatTableModule, MatAutocompleteModule, MatRadioModule, MatIconModule, MatNativeDateModule, MatProgressBarModule, MatDatepickerModule, MatCardModule, MatPaginatorModule, MatSortModule, MatCheckboxModule, MatSnackBarModule, MatTabsModule, MatTooltipModule, MatDialogModule, MatFormFieldModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material';

import * as _ from 'lodash';

import { SplashScreenService, ContentAnimateDirective, LayoutConfigService, MenuConfigService, PageConfigService, LayoutRefService, MenuHorizontalService, SubheaderService, FakeApiService, KtDialogService } from './app/core/_base/layout';
// State
import { metaReducers, reducers } from './app/core/reducers';

import { PagesModule } from './app/views/pages/pages.module';
import { PartialsModule } from './app/views/partials/partials.module';

import { AppComponent } from './app/app.component';

import { SplashScreenComponent } from './app/views/partials/layout/splash-screen/splash-screen.component';
import { ThemeModule } from './app/views/theme/theme.module';
import { AbpMultiTenancyService } from 'abp-ng2-module/dist/src/multi-tenancy/abp-multi-tenancy.service';
import { StoreFeatureModule, StoreModule, ReducerManager } from '@ngrx/store';
import { AppAuthService } from './shared/auth/app-auth.service';
import { AppRouteGuard } from './shared/auth/auth-route-guard';
import { AppModule } from './app/app.module';
import { MessageService } from 'abp-ng2-module/dist/src/message/message.service';
import { LogService } from 'abp-ng2-module/dist/src/log/log.service';
import { RouterModule } from '@angular/router';
import { PermissionCheckerService } from 'abp-ng2-module/dist/src/auth/permission-checker.service';
import { LocalizationService } from 'abp-ng2-module/dist/src/localization/localization.service';
import { FeatureCheckerService } from 'abp-ng2-module/dist/src/features/feature-checker.service';
import { NotifyService } from 'abp-ng2-module/dist/src/notify/notify.service';
import { SettingService } from 'abp-ng2-module/dist/src/settings/setting.service';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
import { TokenService } from 'abp-ng2-module/dist/src/auth/token.service';
import { LayoutModule } from '@angular/cdk/layout';
import { AnimationBuilder } from '@angular/animations';

import { NgxPermissionsService, NgxPermissionsStore, NgxPermissionsModule } from 'ngx-permissions';
import { TranslateService, TranslateStore, TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';


import { InlineSVGModule } from 'ng-inline-svg';
import { CoreModule } from './app/core/core.module';
import { PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { LayoutConfig } from './app/core/_config/layout.config';
import { environment } from './environments/environment';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// Highlight JS
import { HIGHLIGHT_OPTIONS, HighlightLanguage } from 'ngx-highlightjs';
import * as typescript from 'highlight.js/lib/languages/typescript';
import * as scss from 'highlight.js/lib/languages/scss';
import * as xml from 'highlight.js/lib/languages/xml';
import * as json from 'highlight.js/lib/languages/json';
import { CustomHttpInterceptor } from './shared/service-proxies/custom-http-interceptor';
import { AbpHttpConfiguration } from './shared/service-proxies/abp-http-configuration';
import { CustomMessageService } from './shared/service-proxies/custom-message.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './app/core/auth';
import { HttpUtilsService } from './app/core/_base/crud';
import { LoginModule } from './app/views/pages/transpop/login/login.module';
import { AdminModule } from './app/views/pages/transpop/admin/admin.module';
import { AbpHttpInterceptor } from 'abp-ng2-module/dist/src/abpHttpInterceptor';
import { AppInitializer } from 'app-initializer';
import { GlobalErrorHandlerService } from '@shared/services/global-error-handler.service';
import { AppPublicModule } from 'app-public/app-public.module';
import { GMapsService } from '@app/views/pages/smartrouting/service/gmaps.service';
import { SROsmsService } from '@app/views/pages/smartrouting/service/osm.service';


// declare const abp;

// // tslint:disable-next-line:class-name
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
// 	wheelSpeed: 0.5,
// 	swipeEasing: true,
// 	minScrollbarLength: 40,
// 	maxScrollbarLength: 300,
// };

// export function initializeLayoutConfig(appConfig: LayoutConfigService) {
// 	// initialize app by loading default demo layout config
// 	return () => {
// 		if (appConfig.getConfig() === null) {
// 			appConfig.loadConfigs(new LayoutConfig().configs);
// 		}
// 	};
// }

// export function hljsLanguages(): HighlightLanguage[] {
// 	return [
// 		{name: 'typescript', func: typescript},
// 		{name: 'scss', func: scss},
// 		{name: 'xml', func: xml},
// 		{name: 'json', func: json}
// 	];
// }


// export function appInitializerFactory(injector: Injector,
//     platformLocation: PlatformLocation) {
//     return () => {

//         //abp.ui.setBusy();
//         return new Promise<boolean>((resolve, reject) => {
//             AppConsts.appBaseHref = getBaseHref(platformLocation);
//             const appBaseUrl = getDocumentOrigin() + AppConsts.appBaseHref;

//             AppPreBootstrap.run(appBaseUrl, () => {
//                 abp.event.trigger('abp.dynamicScriptsInitialized');
//                 const appSessionService: AppSessionService = injector.get(AppSessionService);
//                 appSessionService.init().then(
//                     (result) => {
//                        // abp.ui.clearBusy();

//                         if (shouldLoadLocale()) {
//                             const angularLocale = convertAbpLocaleToAngularLocale(abp.localization.currentLanguage.name);
//                             import(`@angular/common/locales/${angularLocale}.js`)
//                                 .then(module => {
//                                     registerLocaleData(module.default);
//                                     resolve(result);
//                                 }, reject);
//                         } else {
//                             resolve(result);
//                         }
//                     },
//                     (err) => {
//                         //abp.ui.clearBusy();
//                         reject(err);
//                     }
//                 );
//             });
//         });
//     };
// }

// export function convertAbpLocaleToAngularLocale(locale: string): string {
//     if (!AppConsts.localeMappings) {
//         return locale;
//     }

//     const localeMapings = _.filter(AppConsts.localeMappings, { from: locale });
//     if (localeMapings && localeMapings.length) {
//         return localeMapings[0]['to'];
//     }

//     return locale;
// }

export function shouldLoadLocale(): boolean {
    return abp.localization.currentLanguage.name && abp.localization.currentLanguage.name !== 'en-US';
}

export function getRemoteServiceBaseUrl(): string {
    return AppConsts.remoteServiceBaseUrl;
}

export function getCurrentLanguage(): string {
    if (abp.localization.currentLanguage.name) {
        return abp.localization.currentLanguage.name;
    }

    // todo: Waiting for https://github.com/angular/angular/issues/31465 to be fixed.
    return 'en';
}

@NgModule({
    imports: [


    //AppComponent,
      // AppModule,
       BrowserModule,
    ApplicationModule,
   // CommonModule,
        //BrowserModule,
        BrowserAnimationsModule,
        //SharedModule.forRoot(),
        ModalModule.forRoot(),
        HttpClientModule,
		environment.isMockEnabled ? HttpClientInMemoryWebApiModule.forRoot(FakeApiService, {
			passThruUnknownUrl: true,
			dataEncapsulation: false
		}) : [],
		NgxPermissionsModule.forRoot(),
       // RouterModule,
       OverlayModule,
		StoreModule.forRoot(reducers, {metaReducers}),
		EffectsModule.forRoot([]),
        StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
        //AuthModule.forRoot(),
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,
        InlineSVGModule.forRoot(),

        //Transpop Modules
        LoginModule.forRoot(),
		//AdminModule.forRoot(),
        SharedModule.forRoot(),
        
        AppPublicModule,
        
        //StoreDevtoolsModule.instrument(),
        //AbpModule,
        //ServiceProxyModule,
        CoreModule,
        RootRoutingModule,
        HttpClientModule,
        //LayoutModule,
       // PagesModule,
       //PartialsModule,
		ThemeModule,
        

     //ServiceProxyModule,
   

     // angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
		
    ],
    declarations: [
       // AppComponent,
        RootComponent
        
     
    ],
    exports: [
       
        
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
        { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        {
            provide: APP_INITIALIZER,
			//useFactory: (appInitializer: AppInitializer) => appInitializer.init(), //appInitializerFactory,
			useFactory: (initializeApp1),
			deps: [AppInitializer, Injector], //[Injector, PlatformLocation],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLanguage
        },
        { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },

        /*AppSessionService*/
        SessionServiceProxy,
        AbpMultiTenancyService,
       // AppSessionService,
                //AppUrlService,
                AuthService,
                HttpUtilsService,
                AppAuthService,
                AppRouteGuard,
                //AbpHttpConfiguration,
                AbpHttpConfiguration,
                MessageService,
                LogService,
                PermissionCheckerService,
                LocalizationService,
                FeatureCheckerService,
                NotifyService,
                SettingService,
                TokenAuthServiceProxy,
                TokenService,
                UtilsService,
                LayoutConfigService,
                SplashScreenService,/* ,
                {
                    provide: PERFECT_SCROLLBAR_CONFIG,
                    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
                }, */
                MenuConfigService,
                PageConfigService,
                LayoutRefService,
                MenuHorizontalService,
                UserServiceProxy,
                AccountServiceProxy,
                OrderApprovalRulesServiceProxy,

                CustomerServiceProxy,
                CustomerThemeServiceProxy,
                PageServiceProxy,
                WarehouseServiceProxy,
                ProductServiceProxy,
		UserPermissionServiceProxy,
		UserCitiesCategoriesServiceProxy,
		AddressServiceProxy,
		UserAddressServiceProxy,
		ReportServiceProxy,
		UserReportServiceProxy,
		TitleServiceProxy,
		UserCustomerServiceProxy,
		UserAuthorizationServiceProxy,
		AuthorizationTypeServiceProxy,
		UserCitiesServiceProxy,
		CityServiceProxy,
		CategoryServiceProxy,
		UserWarehouseServiceProxy,
		UserFormsServiceProxy,
		UserProductAttributeServiceProxy,
		ProductAttributeServiceProxy,
		OrderApprovalTaskRepairServiceProxy,
		UserManagementSummaryServiceProxy,
		WarehouseOwnerServiceProxy,
        MetabaseTranspopPortalModuleServiceProxy,
		MetabaseTranspopPortalFilterServiceProxy,
        MetabaseTranspopPortalProcessServiceProxy,
		ProductDamageStatusServiceProxy,
		UserPagesServiceProxy,
		ModuleServiceProxy,
		UserModuleServiceProxy,
        UserRoleServiceProxy,
        PosmProductionServiceProxy,
        PosmProductionRequestServiceProxy,
        TransportBidServiceProxy,
		ResolveServiceProxy,
		ProcessTrackingServiceProxy,
		GoogleMapsServiceProxy,
		RouteServiceProxy,
        OrderCartServiceProxy,
        UserRouteStartLocationServiceProxy,
                SubheaderService,
                KtDialogService,
                CustomMessageService,
                
                ContentAnimateDirective,
                NgxPermissionsService,
                NgxPermissionsStore,
               TranslateStore,
               ReducerManager,
		AppSessionService,
        GMapsService,
        SROsmsService

    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    bootstrap: [RootComponent]
})

export class RootModule {

}

export function initializeApp1(appInitService: AppInitializer, injector: Injector) {
	return appInitService.init(injector);
};

export function getBaseHref(platformLocation: PlatformLocation): string {
    const baseUrl = platformLocation.getBaseHrefFromDOM();
    if (baseUrl) {
        return baseUrl;
    }

    return '/';
}

function getDocumentOrigin() {
    if (!document.location.origin) {
        const port = document.location.port ? ':' + document.location.port : '';
        return document.location.protocol + '//' + document.location.hostname + port;
    }

    return document.location.origin;
}
